import {Lifetime} from "./Lifetime";
import {Semaphore} from "./concurrency/Semaphore";
import {delay} from "./concurrency/Delay";
import {TimeoutError, withTimeout} from "./concurrency/WithTimeout";

export function startHeartbeat({ping, lifetime, pingInterval = 15_000, pongTimeout = 45_000}: {
    ping: (pingTs: number) => void,
    lifetime: Lifetime,
    pingInterval?: number,
    pongTimeout?: number
}): { pong: (pingTs: number) => void } {
    let ongoingPing: {
        pongSemaphore: Semaphore,
        pingTs: number
    } | null = null;

    async function runHeartbeatJob() {
        try {
            while (lifetime.isAlive) {
                await delay(pingInterval);
                if (lifetime.isTerminated) break;

                ongoingPing = {
                    pongSemaphore: new Semaphore(),
                    pingTs: Date.now(),
                };
                const pongPromise = ongoingPing.pongSemaphore.acquire();
                ping(ongoingPing.pingTs);
                await withTimeout(pongTimeout, pongPromise);
            }
        } catch (e) {
            if (e instanceof TimeoutError) {
                lifetime.terminate();
            } else {
                throw e;
            }
        }
    }

    runHeartbeatJob();

    return {
        pong: (pingTs: number) => {
            if (ongoingPing && ongoingPing.pingTs === pingTs) {
                ongoingPing.pongSemaphore.release();
                ongoingPing = null;
            }
        },
    };
}